import UpdatePrescriberInfo from "components/UpdatePrescriberInfo";
import SwitchPrescriberInfo from "components/SwitchPrescriberInfo";
import { formatPhoneNumber, prependCountryCodeToPhoneNumber } from "services/UtilityService";
import { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";
import ConnectCallButton from "components/CallCenterOption/connectCallButton";
import { isLoggedInUserAWSConnectAgent } from "services/AWUtilityService";
import { getLoggedInUser } from "services/AuthService";
import { useSelector } from 'react-redux';
import OverlayBadge from "components/OverlayBadge";
import { VerificationStatus } from "components/SwitchDetails/VerificationStatus";

const PrescriberDetails = (props) => {
  const [prescriber, setPrescriber] = useState(props.prescriber ?? {});
  const callGroupId = useSelector((state) => state?.callGroupDetails?.callGroupData?.callGroupId ?? null);
  const activityId = useSelector((state) => state?.callGroupDetails?.activityDetails?.activityId ?? null)
  const clientId = useSelector((state) =>
   state?.switchDetails?.switchData?.switchInfo?.clientInfo?.clientId ??
  state?.callGroupDetails?.activityDetails?.wfItem?.switchInfo?.clientInfo?.clientId ?? null);
  const customerId = useSelector((state) =>
  state?.switchDetails?.switchData?.switchInfo?.rirCustomerInfo?.customerId ??
  state?.callGroupDetails?.activityDetails?.wfItem?.switchInfo?.rirCustomerInfo?.customerId ?? null);
  const { isDisabled, wfItemId, globalSwitchId } = props;
  const updatePrescriberData = (updatedPrescirber) => {
    setPrescriber(updatedPrescirber);
  };
  const isAWSConnectAgentEnable = isLoggedInUserAWSConnectAgent();

  useEffect(() => {
    setPrescriber(props.prescriber);
  }, [props.prescriber]);

  return (
    <>
      <Row>
        <Col xs={12} sm={9}>
          <div data-testid='text-prescriber-name'>
            {prescriber.prescriberName}
            {!props.isFromAW && (
              <>
                <OverlayBadge className="custom-badge" placement="top" bg="warning" badgeText={prescriber.state} hoverText={prescriber.rescheduleInterval}/>
              </>
            )}
            &nbsp;
            { prescriber.optedOut ?
              <Badge bg="warning" pill data-testid='badge-prescriber-opt-out'>
                Opted Out
              </Badge>
              :
              <></>
            } &nbsp;
            { prescriber.gatekeeper ?
              <Badge bg="warning" pill data-testid='badge-prescriber-gatekeeper'>
                Gatekeeper
              </Badge>
              :
              <></>
            }
          </div>
          <div style={{ fontSize: "0.8em" }} data-testid='text-prescriber-practice'>
            {prescriber.prescriberPractice}{" "}
          </div>
        </Col>
        <Col xs={12} sm={3}>
          <div className="rm-tiny-top-label">Suffix</div>
          <div data-testid='text-prescriber-credentials'>
            {prescriber.prescriberNameCredentialText
              ? prescriber.prescriberNameCredentialText
              : "N/A"}
          </div>
        </Col>
      </Row>
      {!isDisabled ? (
        <UpdatePrescriberInfo
          prescriber={prescriber}
          isDisabled={isDisabled}
          onSubmission={updatePrescriberData}
          updateData={props.updateData}
          wfItemId={props.wfItemId}
          isFromAW={props.isFromAW}
          activityType={props.activityType}
        />
      ) : null}
      {!isDisabled ? (
        <SwitchPrescriberInfo
          prescriber={prescriber}
          wfItemId={wfItemId}
          isDisabled={isDisabled}
          onSubmission={updatePrescriberData}
        />
      ) : null}

      <Row className="tiny-top-spacer">
        <Col xs={12} sm={6}>
          <div className="rm-tiny-top-label">Phone
            {isAWSConnectAgentEnable && prescriber?.prescriberPhone && (<ConnectCallButton body={{ agent: getLoggedInUser()?.email,
              phone: prependCountryCodeToPhoneNumber(prescriber?.prescriberPhone, 1),
              switchId:globalSwitchId,
              entityName:prescriber.prescriberName,
              entityType:'Prescriber',
              callGroupId : callGroupId,
              activityId: activityId,
              clientId: clientId,
              customerId: customerId }} label='Prescriber'/>)}
          </div>
        </Col>
        <Col xs={12} sm={6}>
          <div className="rm-tiny-top-label">Time Zone</div>
          <div data-testid='text-prescriber-timezone'>{prescriber.timeZone ? prescriber.timeZone : "N/A"}</div>
        </Col>
      </Row>
      <Row>
      <div
        data-testid='text-prescriber-phone'
        style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "0.5rem", minWidth: 0 }}
      >
        <span className="text-nowrap">{formatPhoneNumber(prescriber.prescriberPhone)}</span>
        <span className="text-nowrap"><VerificationStatus verified={prescriber.verifiedPhone === true} /></span>
      </div>
      </Row>
      <div className="rm-tiny-top-label tiny-top-spacer">Fax</div>
      <div
        data-testid='text-prescriber-fax'
        style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "0.5rem", minWidth: 0 }}
      >
        <span className="text-nowrap">{formatPhoneNumber(prescriber.prescriberFax)}</span>
        <span className="text-nowrap"><VerificationStatus verified={prescriber.verifiedFax === true} /></span>
      </div>
      <div className="rm-tiny-top-label tiny-top-spacer">Npi</div>
      <div data-testid='text-prescriber-npi'>{prescriber.prescriberNpi}</div>
      <div className="rm-tiny-top-label tiny-top-spacer">Address</div>
      <div data-testid='text-prescriber-address'>{prescriber.prescriberAddress ? prescriber.prescriberAddress : "N/A"}</div>
    </>
  );
};

export default PrescriberDetails;
